var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburgerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 210 210",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f3e9d7;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mesa de trabajo 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M195,0H175a15,15,0,0,0-15,15V35a15,15,0,0,0,15,15h20a15,15,0,0,0,15-15V15A15,15,0,0,0,195,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M115,0H95A15,15,0,0,0,80,15V35A15,15,0,0,0,95,50h20a15,15,0,0,0,15-15V15A15,15,0,0,0,115,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M35,0H15A15,15,0,0,0,0,15V35A15,15,0,0,0,15,50H35A15,15,0,0,0,50,35V15A15,15,0,0,0,35,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M195,160H175a15,15,0,0,0-15,15v20a15,15,0,0,0,15,15h20a15,15,0,0,0,15-15V175A15,15,0,0,0,195,160Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M115,160H95a15,15,0,0,0-15,15v20a15,15,0,0,0,15,15h20a15,15,0,0,0,15-15V175A15,15,0,0,0,115,160Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M35,160H15A15,15,0,0,0,0,175v20a15,15,0,0,0,15,15H35a15,15,0,0,0,15-15V175A15,15,0,0,0,35,160Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M195,80H175a15,15,0,0,0-15,15v20a15,15,0,0,0,15,15h20a15,15,0,0,0,15-15V95A15,15,0,0,0,195,80Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M115,80H95A15,15,0,0,0,80,95v20a15,15,0,0,0,15,15h20a15,15,0,0,0,15-15V95A15,15,0,0,0,115,80Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M35,80H15A15,15,0,0,0,0,95v20a15,15,0,0,0,15,15H35a15,15,0,0,0,15-15V95A15,15,0,0,0,35,80Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerIcon);
export default __webpack_public_path__ + "static/media/hamburger_icon.e6f2eedefdb86df6b053670061e1211e.svg";
export { ForwardRef as ReactComponent };